import FieldImageUpload from './FieldImageUpload';

export default FieldImageUpload;
